import {
  EuiColorPicker,
  EuiColorPickerSwatch,
  EuiFormRow,
} from "@inscopix/ideas-eui";
import { DEFAULT_FOLDER_COLOR } from "components/ProjectTablesTable/ProjectTablesTable.helpers";
import { isNonNull } from "utils/isNonNull";

interface FieldFolderColorProps {
  autoFocus?: boolean;
  label?: string;
  placeholder?: string;
  value: string | null;
  isValid: boolean;
  onChange: (field: { value: string | null; isValid: boolean }) => void;
}

export const FieldFolderColor = ({
  autoFocus,
  placeholder = "Default",
  value,
  onChange,
}: FieldFolderColorProps) => {
  return (
    <EuiFormRow hasEmptyLabelSpace>
      <EuiColorPicker
        aria-label="Folder color"
        mode="swatch"
        onChange={(color, { isValid }) => {
          onChange({
            value: color !== "" ? color : null,
            isValid: color === null ? true : isValid,
          });
        }}
        secondaryInputDisplay="bottom"
        button={
          <EuiColorPickerSwatch
            color={isNonNull(value) ? value : DEFAULT_FOLDER_COLOR}
            aria-label="Select a new color"
          />
        }
        color={value}
        isInvalid={false}
        placeholder={placeholder}
        isClearable={true}
        autoFocus={autoFocus}
      />
    </EuiFormRow>
  );
};
